import React, { createElement, useContext } from 'react'

// Node Modules
import { domToReact, DomElement } from 'html-react-parser'

// Components
import Carousel from 'components/xis/Carousel'
import { Item } from 'components/xis/Carousel'

// Context
import { LanguageContext } from 'context/language-context'
import { DocsetContext } from 'context/content-context'

// Util
import { hasAttrib } from 'util/xis-parser/conditions'
import { docsetImage } from 'util/links'

export default ({ attribs, children }:DomElement, params:any, options:any) => {
  const language = useContext(LanguageContext)
  const docset = useContext(DocsetContext)

  const empty = <></>

  const carouselId = attribs?.id

  if (!children || !language || !docset) {
    return empty
  }

  const items = children.reduce((accum, child) => {
    if (!child.children || !child.attribs) {
      return accum
    }

    let src = child.attribs['data-image']
    const alt = child.attribs['data-alt']

    if (!src || !alt) {
      return accum
    }

    const [,file] = src.split('images/')

    src = docsetImage(docset.id, docset.version, file, language)

    const title = child.children.find(c => hasAttrib(c, 'data-sas-slide-title'))
    const content = child.children.find(c => hasAttrib(c, 'data-sas-slide-content'))

    const titleEl = title && domToReact([title], options)
    const contentEl = content && domToReact([content], options)

    return accum.concat({
      src,
      alt,
      title: titleEl as React.ReactNode,
      content: contentEl as React.ReactNode
    })
  }, [] as Item[])

  const noWrap:boolean = (attribs && attribs['data-no-wrap'] === 'true') || false
  
  return createElement(
    Carousel, 
    {
      carouselId,
      items,
      noWrap
    }, 
    domToReact(children, options)
  )
}